export default __webpack_public_path__ + "static/media/fajitas.de511e23.jpg";